import { TFilterIds } from '../components/FilterItems/FilterItem';

export const getFilterIdFromContentUrl = (contentUrl: string) =>
  contentUrl.replace('api/v2/filters/', '').replace('/content', '') as TFilterIds;
